"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GoogleButton", {
  enumerable: true,
  get: function get() {
    return _GoogleButton2.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _GoogleButton2.default;
  }
});

var _GoogleButton2 = _interopRequireDefault(require("./GoogleButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }